import { Dialog, DialogActions, DialogContent, DialogTitle } from "@mui/material";
import { CheckboxGroupInput, EditBase, Form, SaveButton, useRecordContext, useUpdate } from "react-admin";
import { reportError } from "../backoffice.utils";
import { DrivingLicenseClass, DrivingLicenseClassEnum } from "../model/DrivingLicenseClass";
import { DialogCloseButton } from "../misc/DialogCloseButton";
import { Student } from "../providers/studentsProvider";

export function EditDrivingLicenseClassesDialog(props: { open: boolean; onClose: () => void }): JSX.Element {
  const { open, onClose } = props;

  const record = useRecordContext<Student>();
  const [update] = useUpdate<Student>();

  const onSubmit = async (drivingLicenseClasses: DrivingLicenseClass[]) => {
    await runSafely(
      () =>
        update("students", {
          id: record.id,
          data: { previousDrivingLicenseClasses: drivingLicenseClasses },
          previousData: record,
        }),
      {
        errorMessage: `Fehler beim Ändern der Vorbesitz Führerscheinklassen von ${record.name ?? "dem Eintrag"}.`,
        successMessage: `Vorbesitz Führerscheinklassen von ${record.name ?? "..."} erfolgreich geändert.`,
        onError: (error) =>
          reportError(`Failed to change Vorbesitz Führerscheinklassen of students ${record?.id}`, error),
        onSuccess: onClose,
      },
    );
  };

  return (
    <Dialog open={open} onClose={onClose}>
      <DialogTitle>{`Vorbesitz Führerscheinklassen von ${record?.name ?? "..."}`}</DialogTitle>
      <DialogCloseButton onClick={onClose} />
      <EditBase>
        <Form
          onSubmit={(data) => {
            const drivingLicenseClasses = data.previousDrivingLicenseClasses;
            void onSubmit(drivingLicenseClasses);
          }}
          warnWhenUnsavedChanges
        >
          <DialogContent>
            <CheckboxGroupInput
              source="previousDrivingLicenseClasses"
              choices={DrivingLicenseClassEnum.options.map((drivingLicenseClasses) => ({
                id: drivingLicenseClasses,
                name: drivingLicenseClasses,
              }))}
              label=""
              sx={{
                width: "100%",
                "& .MuiFormGroup-root": {
                  display: "grid",
                  gridTemplateColumns: "repeat(6, 1fr)",
                  gap: "8px",
                  "& .MuiCheckbox-root": { width: "auto" },
                },
              }}
            />
          </DialogContent>
          <DialogActions>
            <SaveButton icon={<></>} />
          </DialogActions>
        </Form>
      </EditBase>
    </Dialog>
  );
}
